var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyTeamsPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 6.66667C7.622 6.66667 8.66667 5.622 8.66667 4.33333C8.66667 3.04467 7.622 2 6.33333 2C5.04467 2 4 3.04467 4 4.33333C4 5.622 5.04467 6.66667 6.33333 6.66667Z",
    stroke: "#9E5A17",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8691 2.3335C11.5467 2.7418 11.9999 3.48473 11.9999 4.3335C11.9999 5.18226 11.5467 5.9252 10.8691 6.3335",
    stroke: "#9E5A17",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 13.6002V14.0002H11.333V13.6002C11.333 12.1067 11.333 11.36 11.0424 10.7895C10.7867 10.2878 10.3787 9.8798 9.87697 9.62413C9.30654 9.3335 8.55981 9.3335 7.06634 9.3335H5.59967C4.10621 9.3335 3.35947 9.3335 2.78903 9.62413C2.28727 9.8798 1.87932 10.2878 1.62366 10.7895C1.33301 11.36 1.33301 12.1067 1.33301 13.6002Z",
    stroke: "#9E5A17",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 14V13.6C14.667 12.1066 14.667 11.3598 14.3763 10.7894C14.1207 10.2876 13.7127 9.87969 13.2109 9.62402",
    stroke: "#9E5A17",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTeamsPerson);
export default __webpack_public_path__ + "static/media/my-teams-person.f443ed977a6ff16445a07a7e3b4437b1.svg";
export { ForwardRef as ReactComponent };